import React, { useEffect } from "react";
import { useLoginFakeMutation } from "src/services";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

const FakeLogin = () => {
  const [loginFake, { data, isSuccess }] = useLoginFakeMutation();
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (searchParams.get("matricula")) {
      loginFake({ matricula: searchParams.get("matricula") });
    }
  }, [location, searchParams, loginFake]);

  useEffect(() => {
    if (isSuccess) {
      localStorage.setItem("token", data.data.token);
      localStorage.setItem("refreshToken", JSON.stringify(data.data.refreshToken));
      navigate("/");
    }
  }, [data, isSuccess, navigate]);

  return <></>;
};

export default FakeLogin;
